import Enums from "../../../../model/enums";
import {ty} from "./ty";

export default {
  id: Enums.SeTaxFormType.tf8582,
  pdf: `static/forms/${ty}/${ty}_8582.pdf`,
  route: `/se-eval/std-tax-form-8582/${Enums.SeTaxFormType.tf8582}/${ty}`,
  fields: [
    {
      id: "netLoss8582RentalAmount",
      fieldName: "topmostSubform[0].Page1[0].Table_Part4[0].Row1[0].f1_22[0]",
      fieldHighlights: [
        "topmostSubform[0].Page1[0].Table_Part4[0].Row1[0].f1_22[0]",
        "topmostSubform[0].Page1[0].Table_Part4[0].Row2[0].f1_28[0]",
        "topmostSubform[0].Page1[0].Table_Part4[0].Row3[0].f1_34[0]",
        "topmostSubform[0].Page1[0].Table_Part4[0].Row4[0].f1_40[0]",
        "topmostSubform[0].Page1[0].Table_Part4[0].Row5[0].f1_46[0]"
      ],
      label: "(b) Net Loss for the business that Income Calculator is evaluating",
      line: "Part IV, (b) Net Loss (line 1b)",
      isCurrency: true,
      isPositive: false,
      hasHelp: true,
      pageHeader: "Find Form 8582, Part IV"
    },
    {
      id: "netLoss8582OtherAmount",
      fieldName: "topmostSubform[0].Page2[0].Table_Part5[0].Row1[0].f2_03[0]",
      fieldHighlights: [
        "topmostSubform[0].Page2[0].Table_Part5[0].Row1[0].f2_03[0]",
        "topmostSubform[0].Page2[0].Table_Part5[0].Row2[0].f2_09[0]",
        "topmostSubform[0].Page2[0].Table_Part5[0].Row3[0].f2_15[0]",
        "topmostSubform[0].Page2[0].Table_Part5[0].Row4[0].f2_21[0]",
        "topmostSubform[0].Page2[0].Table_Part5[0].Row5[0].f2_27[0]"
      ],
      label: "(b) Net Loss for the business that Income Calculator is evaluating",
      line: "Part V, (b) Net Loss (line 2b)",
      isCurrency: true,
      isPositive: false,
      hasHelp: true,
      pageHeader: "Find Form 8582, Part V"
    }
  ]
}

